export var getInputAccessibilityDescriptionId = function getInputAccessibilityDescriptionId(errorId, descriptionId, isInvalid) {
  if (isInvalid && errorId) {
    return "".concat(errorId, " ").concat(descriptionId);
  }
  return descriptionId;
};